(function () {
  var KEY = "W9GfDD", LIST = "UkLxpU";

  var st=document.createElement("style");
  st.textContent=".template--lilbaby-drop .lb-form button{font-size:19px!important;padding:1.2rem!important}"
  +".template--lilbaby-drop .sb-text{font-size:15px!important}"
  +".template--lilbaby-drop .sb-text strong{font-size:17px!important}"
  +".template--lilbaby-drop .sb-cta{font-size:16px!important;padding:.9rem 1.2rem!important}";
  document.head.appendChild(st);

  function track(ev,p){p=p||{};
    try{window.fbq&&fbq("track",ev==="Lead"?"Lead":"CustomizeProduct",p);}catch(e){}
    try{window.gtag&&gtag("event",ev,p);}catch(e){}
    try{window.ttq&&ttq.track(ev==="Lead"?"SubmitForm":"ClickButton",p);}catch(e){}
  }
  function toE164(r){var d=(r||"").replace(/[^\d+]/g,"");if(d[0]==="+")return d;if(d.length===10)return"+1"+d;if(d.length===11&&d[0]==="1")return"+"+d;return d?"+"+d:"";}

  function klaviyo(attrs){
    var payload={data:{type:"subscription",attributes:{profile:{data:{type:"profile",attributes:attrs}}},relationships:{list:{data:{type:"list",id:LIST}}}}};
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+KEY,{
      method:"POST",headers:{"Content-Type":"application/json",revision:"2024-10-15"},body:JSON.stringify(payload)});
  }

  var isUSA=false;
  fetch("https://ipapi.co/country/").then(function(r){return r.text();}).then(function(c){
    isUSA=(c.trim()==="US"); initForms();
  }).catch(function(){ isUSA=false; initForms(); });

  function initForms(){ document.querySelectorAll(".lb-form").forEach(function(f){ setupForm(f); }); }

  function setupForm(form){
    var phoneStep=form.querySelector(".lb-step-phone");
    var emailStep=form.querySelector(".lb-step-email");
    var msg=form.querySelector(".lb-msg");
    var id=form.getAttribute("data-form-id");
    var capturedPhone="";

    function showMsg(t){ if(msg){msg.hidden=false;msg.textContent=t;} }
    function done(text){ form.classList.add("success");
      form.innerHTML='<div class="success-mark">\u2713</div><h3>You\u2019re on the list.</h3><p>'+text+'</p>'; }

    if(isUSA){ phoneStep.hidden=false; } else { emailStep.hidden=false; }

    var nextPhone=form.querySelector(".lb-next-phone");
    if(nextPhone){ nextPhone.addEventListener("click",function(){
      var phone=toE164(form.phone.value.trim());
      if(!phone||phone.length<11){ showMsg("Enter a valid phone number."); return; }
      capturedPhone=phone; nextPhone.disabled=true; nextPhone.textContent="Saving\u2026";
      track("ButtonClick",{form:id,step:"phone"});
      klaviyo({phone_number:phone}).then(function(){
        track("Lead",{form:id,step:"phone"});
        phoneStep.hidden=true; emailStep.hidden=false; if(msg)msg.hidden=true;
      }).catch(function(){ nextPhone.disabled=false; nextPhone.textContent="NOTIFY ME BY TEXT"; showMsg("Something went wrong. Try again."); });
    }); }

    var emailBtn=form.querySelector(".lb-submit-email");
    if(emailBtn){ emailBtn.addEventListener("click",function(){
      var email=form.email.value.trim();
      if(!email||email.indexOf("@")<1){ showMsg("Enter a valid email."); return; }
      emailBtn.disabled=true; emailBtn.textContent="Saving\u2026";
      track("ButtonClick",{form:id,step:"email"});
      var attrs={email:email}; if(capturedPhone)attrs.phone_number=capturedPhone;
      klaviyo(attrs).then(function(){
        track("Lead",{form:id,step:"email"});
        done(capturedPhone?"Watch your texts and inbox. Early access drops first to this list.":"Watch your inbox. Early access drops first to this list.");
      }).catch(function(){ emailBtn.disabled=false; emailBtn.textContent="GET EARLY ACCESS"; showMsg("Something went wrong. Try again."); });
    }); }
  }

  var cd=document.getElementById("lb-countdown"),banner=document.getElementById("lb-cd-banner");
  if(cd){ var dl=new Date(cd.getAttribute("data-deadline")).getTime(),p=function(n){return String(n).padStart(2,"0");};
    var tick=function(){ var diff=dl-Date.now(),live=diff<=0; if(live)diff=0;
      var d=Math.floor(diff/86400000),h=Math.floor((diff/3600000)%24),m=Math.floor((diff/60000)%60),s=Math.floor((diff/1000)%60);
      cd.querySelector("[data-d]").textContent=p(d);cd.querySelector("[data-h]").textContent=p(h);
      cd.querySelector("[data-m]").textContent=p(m);cd.querySelector("[data-s]").textContent=p(s);
      if(banner)banner.textContent=live?"IT'S LIVE":("DROPS IN "+d+"D "+h+"H "+m+"M"); };
    tick(); setInterval(tick,1000);
  }
})();
